import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';

import { MultiSelectCombobox } from '../../../components';

import css from './MultiSelectWithSearch.module.css';

/**
 * MultiSelectWithSearch — FILTERS-04
 *
 * Filtro de selección múltiple con buscador para el SearchPage.
 *
 * FASE2-WIZARD-2b: el combobox en sí vive ahora en components/MultiSelectCombobox,
 * y este componente se queda con lo que es propio del FILTRO: el contrato de
 * query params (queryParamNames / initialValues / onSubmit) y el título con su
 * estado activo. El motivo de la extracción es que el wizard del mandato usa el
 * MISMO control para elegir provincias al publicar, y antes la interacción
 * estaba atada a la URL.
 *
 * El comportamiento visible del filtro no cambia.
 */
const MultiSelectWithSearch = props => {
  const {
    label,
    placeholder = 'Todos',
    searchPlaceholder = 'Buscar...',
    options,
    queryParamNames,
    initialValues,
    onSubmit,
  } = props;

  const queryParam = queryParamNames?.[0];
  const initialRaw = queryParam ? initialValues?.[queryParam] : null;

  const initialSelected = useMemo(() => {
    if (!initialRaw) return [];
    // Supports "a,b,c", "has_any:a,b", "has_all:a,b". Strips prefix.
    const raw = String(initialRaw);
    const stripped = raw.startsWith('has_any:')
      ? raw.substring(8)
      : raw.startsWith('has_all:')
      ? raw.substring(8)
      : raw;
    return stripped === '' ? [] : stripped.split(',').filter(Boolean);
  }, [initialRaw]);

  const [selectedValues, setSelectedValues] = useState(initialSelected);

  // Sync state when URL changes externally (clear all, other filter, etc.).
  useEffect(() => {
    setSelectedValues(initialSelected);
  }, [initialSelected]);

  const handleChange = next => {
    setSelectedValues(next);
    onSubmit({ [queryParam]: next.length > 0 ? next.join(',') : null });
  };

  const isPlaceholder = selectedValues.length === 0;

  return (
    <div className={css.root}>
      <div className={css.filterHeader}>
        <p className={classNames(css.label, { [css.labelActive]: !isPlaceholder })}>{label}</p>
      </div>
      <MultiSelectCombobox
        options={options}
        value={selectedValues}
        onChange={handleChange}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        emptyLabel="Sin resultados"
        clearLabel="Limpiar selección"
      />
    </div>
  );
};

export default MultiSelectWithSearch;
